import { FaStarHalfAlt } from 'react-icons/fa';
import { IoStar } from 'react-icons/io5';

const Rating = ({ratings}) => {
  return (
    <div>
      {ratings <= 1 ? (
        <IoStar className="flex gap-[1px] text-lg text-yellow-400" />
      ) : ratings >= 1.5 && ratings < 2 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <FaStarHalfAlt />
        </div>
      ) : ratings <= 2 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
        </div>
      ) : ratings >= 2.5 && ratings < 3 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <FaStarHalfAlt />
        </div>
      ) : ratings <= 3 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <IoStar />
        </div>
      ) : ratings >= 3.5 && ratings < 4 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <IoStar />
          <FaStarHalfAlt />
        </div>
      ) : ratings <= 4 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <IoStar />
          <IoStar />
        </div>
      ) : ratings >= 4.5 && ratings < 5 ? (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <IoStar />
          <IoStar />
          <FaStarHalfAlt />
        </div>
      ) : (
        <div className="flex gap-[1px] text-lg text-yellow-400">
          <IoStar />
          <IoStar />
          <IoStar />
          <IoStar />
          <IoStar />
        </div>
      )}
    </div>
  );
}

export default Rating
